/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import Loading from 'app/components/common/Loading.jsx';
import QueueDetailComponent from 'app/components/Queue/QueueDetailComponent.jsx';
import QueueTabs from 'app/components/Queue/QueueTabs.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import ConfirmModal from 'app/components/common/ConfirmModal.jsx';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import Utilities from 'app/utility/Utilities.js';

class QueueDetailView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editItem: null,
            inputs: [],
            queue: [],
            queueActiveTab: 'queue-list',
            itemsToDelete: [],
            fixedHeader: false,
            bannerTop: 0,
            currentModal: null,
            category: null,
            categories: _.clone(this.props.categories),
            currentPage: 1,
            hasMoreItems: true,
            loadingPage: false,
            initialLoadComplete: false,
            hasHiddenItems: false,
            isEmptyQ: false
        };

        this.onSort = this.onSort.bind(this);
        this.showPostEditModal = this.showPostEditModal.bind(this);
        this.deleteSelected = this.deleteSelected.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.finalizeDelete = this.finalizeDelete.bind(this);
        this.deleteAll = this.deleteAll.bind(this);
        this.rescheduleItem = this.rescheduleItem.bind(this);
        this.moveToTop = this.moveToTop.bind(this);
        this.goToSocial = this.goToSocial.bind(this);
        this.onCategoryFilter = this.onCategoryFilter.bind(this);
        this.scrollHandler = this.scrollHandler.bind(this);

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = {};

        if (props.curation.route !== undefined && Object.keys(props.curation.route).length && props.curation.route.inputs.length && state.inputs.length === 0) {
            nextState.inputs = props.curation.route.inputs;
        }

        return (Object.keys(nextState).length) ? nextState : null;

    }

    componentDidMount() {

        if (this.props.social && this.props.social.id) {
            this.props.getQueue({
                id: this.props.social.id,
                page: this.state.currentPage,
                reset: true
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.social.id !== undefined && prevProps.social.id != this.props.social.id ||
            (prevProps.social.id === undefined && this.props.social.id !== undefined)) {
            this.setState({
                queue: [],
                itemsToDelete: [],
                currentPage: 1,
                hasMoreItems: true,
                isEmptyQ: false
            });
            this.props.getQueue({
                id: this.props.social.id,
                page: this.state.currentPage,
                reset: true
            });
        }

        if (prevProps.posts.created < this.props.posts.created || prevProps.posts.updated < this.props.posts.updated) {
            if (this.props.social.id) {
                this.props.getQueue({
                    id: this.props.social.id,
                    page: this.state.currentPage
                });
            }
            this.props.closeAllModals();
        }

        let orderErrors = this.props.getApiErrors(['QUEUE_ORDER_UPDATE']),
            deleteErrors = this.props.getApiErrors(['QUEUE_DELETE']),
            updateErrors = this.props.getApiErrors(['QUEUE_UPDATE']);
        // check for errors and revert to the prior verion of the list
        if (orderErrors.length || deleteErrors.length || updateErrors.length) {
            let type = '',
                itemsToDelete = [...this.state.itemsToDelete];
            if (orderErrors.length) {
                type = 'QUEUE_ORDER_UPDATE';
            } else if (deleteErrors.length) {
                type = 'QUEUE_DELETE';
                itemsToDelete = [];
            } else if (updateErrors.length) {
                type = 'QUEUE_UPDATE';
            }

            this.setState({
                queue: Utilities.deepClone(this.props.queue.list),
                loadingPage: false,
                itemsToDelete
            });

            this.props.addMessage(UserMessages.generateFlashMessage("The last request couldn't be completed. Your queue has been returned to its prior state.", type));
            this.props.deleteApiError([type]);
        } else {
            if ((prevProps.app.loading.QUEUE_LIST === true && this.props.app.loading.QUEUE_LIST === false) ||
                (prevProps.app.loading.QUEUE_ORDER_UPDATE === true && this.props.app.loading.QUEUE_ORDER_UPDATE === false)) {
                let initialLoadComplete = this.state.initialLoadComplete,
                    hasHiddenItems = this.state.hasHiddenItems,
                    isEmptyQ = this.state.isEmptyQ;

                if ((prevProps.app.loading.QUEUE_LIST === true && this.props.app.loading.QUEUE_LIST === false)) {
                    // reset hidden items flag on a new fetch
                    hasHiddenItems = false;
                    if (this.props.queue.list.length === 0 && this.props.social.qCount > 0) {
                        hasHiddenItems = true;
                    } else if (this.props.queue.list.length === 0) {
                        isEmptyQ = true;
                    } else if (this.props.queue.list.length && isEmptyQ) {
                        // reset isEmptyQ when a category changes that has items
                        isEmptyQ = false;
                    }
                    if (this.props.queue.hasMore === false) {
                        this.setState({
                            hasMoreItems: false
                        });
                    }
                    initialLoadComplete = true;
                }

                this.setState({
                    queue: Utilities.deepClone(this.props.queue.list),
                    loadingPage: false,
                    initialLoadComplete,
                    hasHiddenItems,
                    isEmptyQ
                });

            }

            if ((prevProps.app.loading.QUEUE_UPDATE === true && this.props.app.loading.QUEUE_UPDATE === false) ||
                (prevProps.app.loading.QUEUE_DELETE === true && this.props.app.loading.QUEUE_DELETE === false)) {
                this.props.getQueueCount(this.props.social.id);
                this.props.closeAllModals();
            }
        }

    }

    onSort(items) {

        let filteredItems = _.filter(items, function(item) {
            return item.hasOwnProperty('preview');
        });

        //if (!_.isEqual(this.state.queue, filteredItems)) {
            let idlist = [];

            filteredItems.map((item) => {
                idlist.push(item.id);
            });

            this.props.updateQueueOrder(this.props.social.id, idlist);
        //}

    }

    showPostEditModal(e) {

        let itemId = e.currentTarget.dataset.itemid;
        let editItem = _.find(this.state.queue, function(item) {
            return + item.id === + itemId;
        });

        this.props.persistData("queueItem", editItem);

        this.props.router.navigate("/content/post");

    }


    deleteSelected(item, e) {
        e.preventDefault();

        let id = parseInt(item.id, 10),
            itemList = this.state.itemsToDelete;

        if (itemList.indexOf(id) === -1) {
            item.deleted = true;
            itemList.push(id);
            this.setState({
                itemsToDelete: itemList
            });
        }

    }

    cancelDelete(e) {
        e.preventDefault();
        let item = null;

        for (let i = 0; i < this.state.itemsToDelete.length; ++i) {
            item = _.find(this.state.queue, {id: this.state.itemsToDelete[i]});
            if (item) {
                delete item.deleted
            }
        }

        this.setState({
            itemsToDelete: []
        });

    }

    finalizeDelete(e) {
        e.preventDefault();

        let idlist =  _.clone(this.state.itemsToDelete),
            queue = Utilities.deepClone(this.state.queue),
            nextQueue = [];

        this.props.deleteQueue(this.props.social.id, idlist, false);

        for (let i = 0; i < queue.length; ++i) {
            if (idlist.indexOf(queue[i].id) === -1) {
                nextQueue.push(queue[i]);
            }
        }

        this.setState({
            itemsToDelete: [],
            queue: nextQueue
        });
    }

    deleteAll(e) {
        e.preventDefault();

        let onConfirm = () => {
                this.props.deleteQueue(this.props.social.id, null, true);

                this.setState({
                    itemsToDelete: [],
                    queue: [],
                    isEmptyQ: true
                });

                this.props.closeAllModals();

            },
            onCancel = () => {
                this.props.closeAllModals();
            },
            modal = null;

        modal = (
            <ConfirmModal
                {...this.props}
                modalCopy="Are you sure you want to delete all items from this queue?"
                confirmAction={onConfirm}
                cancelAction={onCancel}
                closeAction={onCancel}/>
        );

        this.props.addModal(modal)

    }

    rescheduleItem(timestamp, itemId) {
        let queue = Utilities.deepClone(this.state.queue),
            data = {
                id: itemId,
                params: {
                    post_ts: 0
                }
            };

        data.params.post_ts = Math.floor(new Date(timestamp).setSeconds(0) / 1000);

        this.props.updateQueue(this.props.social.id, data);

        // update the item in the client side queue as well
        let item = _.find(queue, {id: itemId});
        if (item) {
            item.post_ts = data.params.post_ts;
            item.queuetime = new moment(timestamp).format();
        }

        this.setState({
            queue: queue,
            editItem: itemId
        });

    }

    moveToTop(itemId) {

        let _items = this.state.queue,
            target = _.findWhere(_items, {id: itemId}),
            idlist = [];

        _items = _.without(_items, target);
        _items.unshift(target);

        _items.map((item) => {
            idlist.push(item.id);
        });

        this.props.updateQueueOrder(this.props.social.id, idlist);

    }

    goToSocial(e) {
        e.preventDefault();
        this.props.router.navigate("/config/socials/detail/" + this.props.social.id);
    }

    onCategoryFilter(category, e) {
        let categoryID = this.state.category;

        if (parseInt(category.id, 10) >= 0) {
            categoryID = category.id;
        } else {
            categoryID = null;
        }

        this.setState({
            category: categoryID
        });

        // we need to fetch the queue items again if a category
        // is selected or deselected
        let args = {
            id: this.props.social.id,
            page: 1,
            reset: true
        };
        if (categoryID) {
            args.tagID = categoryID;
        }
        this.props.getQueue(args);

        this.setState({
            currentPage: 1,
            loadingPage: true
        });

    }

    scrollHandler() {

        // fetch already in progress? bail!
        if (this.props.app.loading.QUEUE_LIST === true ||
            this.state.hasMoreItems === false ||
            this.state.loadingPage) {
            return;
        }

        if (this.props.social && this.props.social.id) {
            let nextPage = (this.state.currentPage + 1);

            this.props.getQueue({
                id: this.props.social.id,
                page: nextPage
            });

            this.setState({
                currentPage: nextPage,
                loadingPage: true
            });
        }

    }

    render() {

        let main = null;

		let tabs = (
    			<QueueTabs
    				{...this.props}
                    fixed={this.state.fixedHeader}
    				active={this.state.queueActiveTab}
                    deleteSelected={this.deleteSelected}
                    deleteAll={this.deleteAll}
                    selectedForDelete={this.state.itemsToDelete.length}
                    finalizeDelete={this.finalizeDelete}
                    cancelDelete={this.cancelDelete}
                    onCategoryFilter={this.onCategoryFilter}
                    category={this.state.category}
                    source="queue"/>
		);

        if (this.props.app.userLoaded === false ||
            this.props.app.loading.QUEUE_ORDER_UPDATE === true
        ) {
            main = (
                <Loading/>
            );
        } else if (this.props.social.sched !== undefined && this.props.social.sched.length === 0 && (parseInt(this.props.social.qCount, 10) > 0 && this.state.queue.length === 0)) {
            main = (
                <EmptyState message={"Your queue has items, but no scheduled times. To see what's in your queue, add some scheduled times."}/>
            );
        } else if (this.state.isEmptyQ || this.state.hasHiddenItems) {
            let message = "There are currently no items in your queue. Add items to your queue, and we'll share them on your posting schedule.";
            if (parseInt(this.props.social.activeFlag, 10) === 0) {
                message = (
                    <span>This queue is currently inactive. <a href="#" onClick={this.goToSocial}>Reactivate it</a> and start the posts flowing again.</span>
                ) ;
            }
            if (this.state.hasHiddenItems) {
                message = (
                    <span>
                        Your queue has items, but the content doesn't match any of your categorized schedules.<br/>Add an uncategorized time to see your content. <a href="https://support.dlvrit.com/hc/en-us/articles/9739558980635" target="_blank">Learn more here.</a>
                    </span>
                );
            }
			main = (
				<EmptyState message={message} />
			);
        } else {
            main = (
                <QueueDetailComponent
                    {...this.props}
                    user={this.props.user}
                    inputs={this.state.inputs}
                    moveToTopMethod={this.moveToTop}
                    postModalMethod={this.showPostEditModal}
                    queueList={this.state.queue}
                    removeMethod={this.deleteSelected}
                    rescheduleMethod={this.rescheduleItem}
                    sortMethod={this.onSort}
                    categories={this.props.categories}
                    category={this.state.category}
                    scrollHandler={this.scrollHandler}
                    hasMoreItems={this.state.hasMoreItems}/>
            );
        }

        return (
            <Content
                {...this.props}
                main={main}
                header={tabs}/>
        );
    }

};

QueueDetailView.displayName = "QueueDetailView";

QueueDetailView.propTypes = {
    social: PropTypes.object
};

QueueDetailView.defaultProps = {
    social: {}
};

export default ComponentWithContext(QueueDetailView);
